import { Component, OnInit } from '@angular/core';
import {
  Router,
  ActivatedRoute,
  Params,
  NavigationExtras,
} from '@angular/router';

import * as HttpStatus from 'http-status-codes';

import { BookingsService } from '../../services/bookings.service';
import { MainService } from '../../services/main.service';

import { Helper } from '../../helper';
import { Constants } from '../../constants';

const _ = require('underscore');

@Component({
  selector: 'app-booking-success',
  templateUrl: './booking-success.component.html',
  styleUrls: ['./booking-success.component.scss'],
})
export class BookingSuccessComponent implements OnInit {
  API = this.helper.getApi();
  delete = 'assets/icons/close-green.svg';
  currentBooking = [];
  bookings: any;
  selectedClinic: string;
  current = {};
  bookingId = '-1';
  bookingsNum: number;
  bodyParts = [];
  isBookingSummary = false;
  token: string;
  superClinicId: string;
  singleClinic: string;
  type: string;
  service: string;
  noExperts: string;
  noBodyParts: string;
  active_step: string = 'new';
  show: boolean;
  loading: boolean;
  showDelete: boolean = true;
  currentUser: any = this.helper.getStorage('currentUser');
  allClinics: Array<any> = this.helper.getStorage('allClinics');
  allBookings: Array<any> = this.helper.getStorage('bookings');
  readonly allBodyParts: any = Constants.BODY_PARTS;
  readonly months: any = Constants.MONTHS;
  readonly clinicType = Constants.CLINIC_TYPE;
  readonly flowName: any = Constants.FLOW_TYPE;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public helper: Helper,
    public bookingsService: BookingsService,
    public mainService: MainService
  ) {}

  ngOnInit() {
    let clinic = null;

    this.route.queryParams.subscribe((params: Params) => {
      this.type = params.type;
      this.service = params.service;
      this.singleClinic = params.singleClinic;
      this.selectedClinic = params.clinics;
      this.superClinicId = params.superClinicId;
      this.bookingId = params.bookingId;
      this.bookingsNum = params.bookings;
      this.noExperts = params.noExperts;
      this.noBodyParts = params.noBodyParts;
      this.bookingsNum++;

      if (params.bookingToken) {
        this.token = params.bookingToken;
      }

      if (params.superClinicId) {
        clinic = params.superClinicId;
      }
    });

    const bookingData = this.helper.getBookingData(
      clinic,
      this.currentUser.data.complimentaId
    );

    this.bookingsService
      .getBookings(bookingData, this.clinicType.single)
      .subscribe(this.handleSuccess.bind(this));
  }

  handleSuccess(bookingsResponse) {
    
    if (bookingsResponse.status === HttpStatus.OK) {
      this.loading = true;

      localStorage.removeItem('bodyParts');

      bookingsResponse.response.map((booking) => {
        _.extend(booking, { _id: booking.booking });
      });

      this.bookings = bookingsResponse.response;
      this.currentBooking = this.bookings.filter(
        (booking) => booking.booking === this.bookingId.toLowerCase()
      );
      
      this.currentBooking.map((booking) => {
        try {
          booking.comment = JSON.parse(booking.comment);  
        } catch (error) {
          
        }

        this.arrangeBodyParts(booking);

        this.mainService
          .getTherapists(
            booking.clinic,
            null
          )
          .subscribe((therapistsResponse) => {
            const therapists = therapistsResponse.response;

            const selected_therapist = therapists.filter(
              (therapist) => therapist.id === booking.therapist.toLowerCase()
            )[0];

            booking.therapistData = selected_therapist;

            booking.clinicData = this.allClinics.filter(
              (clinic) => selected_therapist.clinic_id === clinic.id
            )[0];

            booking.date =
              booking.from.substring(8, 10) +
              ' ' +
              this.months[parseInt(booking.from.substring(5, 7))] +
              ' ' +
              booking.from.substring(0, 4);
            booking.dateHeader =
              booking.from.substring(8, 10) +
              ' ' +
              this.months[parseInt(booking.from.substring(5, 7))] +
              ' ' +
              booking.from.substring(0, 4) +
              ' - ' +
              booking.from.substring(11, 16);

            this.isBookingSummary = true;

            this.allBookings.push(this.currentBooking[0]);

            localStorage.setItem('bookings', JSON.stringify(this.allBookings));

            const currentTime = new Date();
            const bookingTime = this.helper.reformatDate(this.currentBooking[0].from);

            const cancelPeriod = this.helper.cancelPeriod(
              bookingTime,
              currentTime,
              this.currentBooking[0]
            );
              
            if (this.currentBooking[0].clinicData.cancelation_period) {

              if (cancelPeriod) {
                this.showDelete = true;
              } else {
                this.showDelete = false;
              }
            } else {
              this.showDelete = true;
            }

            this.loading = false;
          });
      });
    } else {
      console.error('Error', bookingsResponse);
    }
  }

  arrangeBodyParts(booking) {
    let newElements = [];

    if (booking.comment.bodyparts.indexOf(',') > -1) {
      newElements = [];

      const parts = booking.comment.bodyparts.split(',');

      this.allBodyParts.map((part) => {
        if (parts.includes(part.index)) {
          newElements.push(part.name);
        }
      });

      booking.comment.bodyparts = newElements.join(', ');
    } else {
      this.allBodyParts.map((part) => {
        if (booking.comment.bodyparts == part.index)
          booking.comment.bodyparts = part.name;
      });
    }
  }

  export(booking) {
    this.helper.exportPDF(booking);
  }

  bookOfferedVisit() {
    localStorage.setItem(
      'clinicTherapists',
      JSON.stringify([this.currentBooking[0].therapistData.id])
    );
    localStorage.setItem(
      'bodyParts',
      JSON.stringify(
        this.currentBooking[0].comment.bodyparts
          ? this.currentBooking[0].comment.bodyparts.split(',')
          : null
      )
    );

    if (this.currentBooking[0].serviceData.service_type === "KX") {
      localStorage.setItem(
        'expertTherapist',
        JSON.stringify([this.currentBooking[0].therapistData])
      );
    }

    const params = {
      preselected_therapist: 'true',
      clinics: this.currentBooking[0].clinicData.id,
      isExpert: this.currentBooking[0].serviceData.service_type === "KX" ? true : false,
      type: this.type,
      bookings: this.bookingsNum,
      singleClinic: this.singleClinic,
      service: this.type === this.flowName.aalborg ? 'FY' : this.service,
      noExperts: this.noExperts,
      noBodyParts: this.noBodyParts,
    };

    // if superclinic and superclinic + service flow, send params to next page
    if (this.superClinicId) {
      params['superClinicId'] = this.superClinicId;
    }

    const navigationExtras: NavigationExtras = { queryParams: params };

    if (this.type === this.flowName.aalborg) {
      this.router.navigate(['/booking-visit'], navigationExtras);
    } else {
      this.router.navigate(['/service'], navigationExtras);
    }
  }

  reload() {
    const params = {
      type: this.type,
      service: this.service,
      singleClinic: this.singleClinic,
    };

    // if superclinic and superclinic + service flow, send params to next page
    if (this.superClinicId) {
      params['superClinicId'] = this.superClinicId;
    }

    // if singleclinic flow, send clinics params to next page
    if (this.singleClinic === 'true') {
      params['clinics'] = this.selectedClinic;
    }

    const navigationExtras: NavigationExtras = {
      queryParams: params,
    };

    this.router.navigate(['welcome'], navigationExtras);
  }

  openDeletePopup() {
    this.show = true;
  }

  closeDeletePopup() {
    this.show = false;
  }

  deleteBooking(booking: any) {
    this.loading = true;
    this.show = false;

    const bookings = _.reject(this.bookings, function (obj) {
      return obj._id == booking._id;
    });

    const clinic = this.allClinics.filter(
      (clinic) => clinic.id === booking.clinicData.id
    )[0];

    localStorage.removeItem('bookings');
    localStorage.setItem('bookings', JSON.stringify(bookings));

    const user = this.currentUser;

    booking['user'] = user.data.complimentaId;
    booking['clinicName'] = clinic.name;
    booking['clinicAddress'] = clinic.address;
    booking['clinicCity'] = clinic.city;
    booking['clinicPost'] = clinic.post_code;
    booking['clinicRegion'] = clinic.region;
    booking['clinicPhone'] = clinic.phone;
    booking['clientName'] = user.data.firstName;
    booking['flow_url'] = window.location.search;

    this.bookingsService
      .deleteBooking(booking)
      .subscribe(this.handleDeleteSuccess.bind(this));
  }

  handleDeleteSuccess(deleteResponse) {
    this.loading = false;

    const params = {
      type: this.type,
      service: this.service,
      singleClinic: this.singleClinic,
    };

    // if superclinic and superclinic + service flow, send params to next page
    if (this.superClinicId) {
      params['superClinicId'] = this.superClinicId;
    }

    // if singleclinic flow, send clinics params to next page
    if (this.singleClinic === 'true') {
      params['clinics'] = this.selectedClinic;
    }

    const navigationExtras: NavigationExtras = {
      queryParams: params,
    };

    this.router.navigate(['/welcome'], navigationExtras);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/booking-success/booking-success.component.ts